var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirectImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 128,
    viewBox: "0 0 223 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.475 57.8291C204.252 57.8291 207.313 60.8908 207.313 64.6675C207.313 68.4443 204.252 71.5059 200.475 71.5059H166.696C165.562 71.5059 164.762 72.651 164.762 73.7847C164.762 75.8175 166.284 79.1045 168.317 79.1045H180.719C184.495 79.1045 187.557 82.1662 187.557 85.9429C187.557 89.7197 184.495 92.7813 180.719 92.7813H157.579C156.445 92.7813 155.645 93.9264 155.645 95.0601C155.645 97.0929 157.167 100.38 159.2 100.38H186.798C190.575 100.38 193.636 103.442 193.636 107.218C193.636 110.995 190.575 114.057 186.798 114.057H166.119C164.4 114.057 163.243 116.135 163.243 117.855C163.243 121.632 160.181 124.693 156.405 124.693H48.5095C44.7328 124.693 41.6711 121.632 41.6711 117.855C41.6711 114.078 44.7328 111.017 48.5095 111.017H83.4264C85.1459 111.017 86.3026 108.938 86.3026 107.218C86.3026 105.185 84.7808 101.899 82.7479 101.899H60.6668C56.8901 101.899 53.8284 98.8369 53.8284 95.0601C53.8284 91.2833 56.8901 88.2217 60.6668 88.2217H78.2895C79.4233 88.2217 80.2235 87.0767 80.2235 85.9429C80.2235 83.9101 78.7017 80.6231 76.6688 80.6231H70.5108C66.734 80.6231 63.6724 77.5615 63.6724 73.7847C63.6724 72.651 62.8721 71.5059 61.7383 71.5059H39.3921C35.6153 71.5059 32.5537 68.4443 32.5537 64.6675C32.5537 60.8908 35.6153 57.8291 39.3921 57.8291H200.475Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.559 119.987V123.579C172.559 125.562 170.894 127.171 168.843 127.171H124.267C122.216 127.171 120.553 125.562 120.553 123.579V119.929C120.553 109.06 133.398 101.998 146.556 101.998C159.713 101.998 172.559 109.064 172.559 119.929M155.868 70.1844C161.012 75.0995 161.012 83.0691 155.868 87.9842C150.725 92.8993 142.386 92.8993 137.243 87.9842C132.099 83.0691 132.099 75.0995 137.243 70.1844C142.386 65.2693 150.725 65.2693 155.868 70.1844Z",
    fill: "url(#paint0_linear_1373_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.8164 109.658V112.223C88.8164 113.64 87.6273 114.789 86.1627 114.789H54.3223C52.8576 114.789 51.6694 113.64 51.6694 112.223V109.616C51.6694 101.852 60.8447 96.8085 70.2429 96.8085C79.6411 96.8085 88.8164 101.855 88.8164 109.616M76.8949 74.0843C80.5685 77.5951 80.5685 83.2876 76.8949 86.7984C73.2212 90.3092 67.2646 90.3092 63.591 86.7984C59.9164 83.2876 59.9164 77.5951 63.591 74.0843C67.2646 70.5735 73.2212 70.5735 76.8949 74.0843Z",
    fill: "url(#paint1_linear_1373_2)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1373_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 158,
    y: 13,
    width: 65,
    height: 65
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165.799 13.1733L222.263 20.707L214.729 77.1706L158.266 69.6368L165.799 13.1733Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1373_2)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1373_2)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200.009 61.8707L190.599 60.6151L179.2 66.1818C177.509 67.0098 175.563 65.6249 175.814 63.7428L176.483 58.7316C169.425 57.7899 165.347 52.4568 166.289 45.3989L168.173 31.2828C169.114 24.2248 174.447 20.1473 181.505 21.0891L205.032 24.2281C212.09 25.1698 216.167 30.5029 215.226 37.5609L213.342 51.677C212.4 58.7349 207.067 62.8124 200.009 61.8707Z",
    fill: "white",
    stroke: "url(#paint2_linear_1373_2)",
    strokeWidth: 2.14958,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197.779 45.9142C198.846 43.6988 199.732 38.411 194.737 34.9824",
    stroke: "url(#paint3_linear_1373_2)",
    strokeWidth: 0.852295,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195.411 44.6667C196.123 43.1898 196.713 39.6646 193.383 37.3789",
    stroke: "url(#paint4_linear_1373_2)",
    strokeWidth: 0.852295,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1373_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 30,
    width: 25,
    height: 25
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M199.414 39.2894L184.276 30.7422L175.729 45.8804L190.867 54.4276L199.414 39.2894Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1373_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.994 48.641L190.769 45.6482C190.549 45.3526 190.237 45.1378 189.883 45.0373C189.528 44.9367 189.15 44.956 188.807 45.092L187.278 45.7073C186.348 43.9638 185.811 42.0372 185.707 40.0637L187.333 39.8012C187.697 39.7414 188.031 39.5628 188.284 39.2933C188.536 39.0237 188.692 38.6783 188.728 38.3107L189.086 34.5985C189.124 34.2042 189.021 33.8092 188.795 33.4839C188.568 33.1587 188.234 32.9242 187.852 32.8223L184.974 32.0575C184.577 31.9525 184.155 31.9968 183.788 32.182C183.422 32.3673 183.136 32.6806 182.984 33.0626C181.624 36.5581 181.432 40.4004 182.437 44.0141C183.443 47.6278 185.592 50.8185 188.563 53.1084C188.625 53.1554 188.689 53.1979 188.756 53.2359C189.079 53.4181 189.454 53.488 189.821 53.4348C190.188 53.3815 190.527 53.2081 190.785 52.9416L192.853 50.799C193.13 50.5148 193.295 50.1414 193.321 49.7459C193.347 49.3504 193.231 48.9586 192.994 48.641Z",
    fill: "url(#paint5_linear_1373_2)"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0891 57.208H34.1615L48.7045 66.8812C50.8615 68.3192 53.7701 66.7835 53.7701 64.169V57.208C63.5744 57.208 70.1105 50.6718 70.1105 40.8675V21.2585C70.1105 11.4542 63.5744 4.91797 53.7701 4.91797H21.0891C11.2848 4.91797 4.74854 11.4542 4.74854 21.2585V40.8675C4.74854 50.6718 11.2848 57.208 21.0891 57.208Z",
    fill: "white",
    stroke: "url(#paint6_linear_1373_2)",
    strokeWidth: 2.95979,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1146 18.4238V21.5718L36.9001 23.4245V21.2099H50.8287V42.1035H43.8642V44.889H53.6142V18.4238H34.1146ZM30.6323 22.6024L20.186 29.5669V44.8896H41.0787V29.5674L30.6323 22.6024ZM39.6856 23.9954V25.2907L41.9285 26.7814H42.4717V23.9954H39.6856ZM45.2572 23.9954V26.7814H48.0427V23.9954H45.2572ZM30.6323 26.0846L38.2931 30.9599V42.1035H34.1146V33.746H27.1501V42.103H22.9715V30.9604L30.6323 26.0846ZM45.2572 29.5669V32.3529H48.0427V29.5669H45.2572ZM45.2572 35.139V37.9245H48.0427V35.139H45.2572Z",
    fill: "url(#paint7_linear_1373_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1373_2",
    x: 160.016,
    y: 19.8801,
    width: 61.4819,
    height: 59.0158,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.32932
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.53173
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.803922 0 0 0 0 0.682353 0 0 0 0 0.878431 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1373_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1373_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1373_2",
    x1: 146.556,
    y1: 66.498,
    x2: 146.556,
    y2: 127.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD44C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#986F1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1373_2",
    x1: 70.2429,
    y1: 71.4512,
    x2: 70.2429,
    y2: 114.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD44C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#986F1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1373_2",
    x1: 190.757,
    y1: 20.9548,
    x2: 190.757,
    y2: 66.4268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD44C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#986F1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1373_2",
    x1: 196.672,
    y1: 34.9824,
    x2: 196.672,
    y2: 45.9142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD44C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#986F1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1373_2",
    x1: 194.673,
    y1: 37.3789,
    x2: 194.673,
    y2: 44.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD44C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#986F1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1373_2",
    x1: 187.563,
    y1: 32.0017,
    x2: 187.563,
    y2: 53.4521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD44C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#986F1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1373_2",
    x1: 37,
    y1: 57.5,
    x2: 37,
    y2: 3.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#986F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD44C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1373_2",
    x1: 37,
    y1: 16,
    x2: 36.9001,
    y2: 44.8896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD44C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#986F1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectImg);
export default __webpack_public_path__ + "static/media/direct-img.b50d9e87e710e2341b82e79ab6a0b925.svg";
export { ForwardRef as ReactComponent };